import axios from 'axios';
import { API_URL } from '../constants/api';
import { LOCAL_STORAGE_AUTH_NAME } from '../constants/utils';
import { ROUTES } from '../constants/routes';

const api = axios.create({
  baseURL: API_URL,
  responseType: 'json',
});

if (localStorage.getItem(LOCAL_STORAGE_AUTH_NAME)) {
  api.interceptors.request.use(
    (config) => {
      const storedAuthData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_AUTH_NAME));
      const token = storedAuthData?.access || '';

      if (token?.length) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
}
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.error('Authorization error');
      localStorage.clear();
      window.location.href = ROUTES.login;
    }
    return Promise.reject(error);
  }
);

export default api;
